import React from "react"

export const styles = {
  full: {
    content: {
      padding: 0,
      maxWidth: "100%"
    }
  },
  normal: {
    content: {
      padding: "20px",
      maxWidth: "100%"
    }
  },
  thin: {
    content: {
      padding: "20px",
      maxWidth: "600px"
    }
  }
}

export default ({ name = "space" } = {}) => ({
  name,
  type: "space",
  component: ({ name: _name, value: _value, onChange }) => {
    return (
      <div>
        <button type="button" value="full" onClick={onChange}>
          Full
        </button>
        <button type="button" value="normal" onClick={onChange}>
          Normal
        </button>
        <button type="button" value="thin" onClick={onChange}>
          thin
        </button>
      </div>
    )
  },
  css: value => {
    const values = styles[value || "normal"]

    const { maxWidth, padding } = values.content

    return `
      .email-container {
        padding-left: ${padding};
        padding-right: ${padding};
        max-width: ${maxWidth};
      }
    `
  }
})
